import Cookies from 'js-cookie';
import { LOADING_MODAL_CLOSE, PROPERTY_MODAL_OPEN } from '../../../store/actions';
import { fetchUnitMaster } from '../../../store/unitMaster/unitMaster.actions';
import { fetchSeasonMaster } from '../../../store/seasonMaster/seasonMaster.actions';
import { fetchPartyDetailsData } from '../../../store/partyDetails/partyDetails.action';
import { fetchCommonPropertyById } from '../../../store/property/common/commonProperty.actions';
import { getIpAddress } from '../../../store/propertyMaster/propertyMaster.actions';
import { fetchHSNMaster } from '../../../store/hsnMaster/hsnMaster.actions';
import { fetchSection } from '../../../store/section/section.actions';
import { exportComponentAsJPEG, exportComponentAsPDF, exportComponentAsPNG } from 'react-component-export-image';
//import { saveAs } from 'file-saver';
import jsPDF from "jspdf";

import html2canvas from 'html2canvas';
import { fetchCompanyMaster, uploadCompanyMasterLogo } from '../../../store/companyMaster/companyMaster.actions';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
//import { Document, Packer, Paragraph, ImageRun, TextRun } from 'docx';


export const KEYS = ['fldS01', 'fldS02', 'fldS03', 'fldS04', 'fldS05', 'fldS06', 'fldS07', 'fldS08', 'fldS09', 'fldS10', 'fldS11', 'fldS12', 'fldS13', 'fldS14', 'fldS15', 'fldS16', 'fldS17', 'fldS18']

export function getCurrentDate() {
    let currentDate = JSON.parse(Cookies.get('USER'));

    let actualDate = currentDate.fldServerCurrentDate.split('T')[0];
    return actualDate;

    // const date = new Date();
    // const year = date.getFullYear();
    // const month = (date.getMonth() + 1).toString().padStart(2, '0');
    // const day = date.getDate().toString().padStart(2, '0');
    // const formattedDateString = `${year}-${month}-${day}`;
    // return formattedDateString;

    // let date = new Date(actualDate);

    // let binaryDate = date.getFullYear().toString(2) + (date.getMonth() + 1).toString(2) + date.getDate().toString(2);
    // return binaryDate;
}

// .background-container {
//     position: relative;
//     width: 100%;
//     height: 100%;
//     background-image: url('/path/to/background-image.jpg');
//     background-size: cover; /* Adjust as needed */
//     background-position: center; /* Center the background image */
//   }

export function EndDateReact() {
    let currentDate = JSON.parse(Cookies.get('USER'));
    let actualDate = currentDate.fldServerCurrentDate.split('T')[0];
    const inputDate = actualDate; // Your input date
    const targetEpoch = new Date('1970-01-01'); // The target epoch (e.g., Unix epoch)
    // Parse the input date
    const inputDateTime = new Date(inputDate);
    // Calculate the timestamp as milliseconds since the target epoch
    const timestamp = inputDateTime.getTime() - targetEpoch.getTime();
    return timestamp;
    // console.log(timestamp); // Output: 1694492998043
}

export function getSupplierAddressDetails(form, program) {
    let field = form?.fldIsInHouseProduction ? 'fldMobileNo' : 'fldPhone'
    if (form?.fldFKSupplierID) {
        let ind = program.findIndex((x) => x?.fldId === form?.fldFKSupplierID);
        if (ind !== -1) {
            let str = `${program[ind]['fldAddress1']}, ${program[ind]['fldAddress2']}, ${program[ind]['fldArea']}, ${program[ind]['fldCity']}, ${program[ind]['fldState']}. \r\nPincode : ${program[ind]['fldPincode']} \r\nPhone : ${program[ind][field]} \r\nGST No. : ${program[ind]['fldGSTNo']} \r\nPAN No : ${program[ind]['fldPANNo']}`;
            return str;
        }
    } else {
        return '';
    }
}

export function getDeliveryAddressDetails(form, program, unitMaster) {
    console.log('form!!!', form)

    if (!form?.fldIsInHouseDelivery) {
        let ind = program.findIndex((x) => x?.fldId == form?.fldFKDeliveryAt);
        if (ind !== -1) {
            let str = `${program[ind]['fldAddress1']}, ${program[ind]['fldAddress2']}, ${program[ind]['fldArea']}, ${program[ind]['fldCity']}, ${program[ind]['fldState']}. \r\nPincode : ${program[ind]['fldPincode']} \r\nPhone : ${program[ind]['fldPhone']} \r\nGST No. : ${program[ind]['fldGSTNo']} \r\nPAN No : ${program[ind]['fldPANNo']}`;
            return str;
        } else {
            return '';
        }
    }

    if (form?.fldIsInHouseDelivery && form.fldFKDeliveryAt) {
        let ind = unitMaster.findIndex((x) => Number(x?.fldId) == Number(form?.fldFKDeliveryAt));
        if (ind !== -1) {
            let str = `${unitMaster[ind]['fldAddress1']}, ${unitMaster[ind]['fldAddress2']}, ${unitMaster[ind]['fldArea']}, ${unitMaster[ind]['fldCity']}, ${unitMaster[ind]['fldState']}. \r\nPincode : ${unitMaster[ind]['fldPincode']} \r\nPhone : ${unitMaster[ind]['fldMobileNo']} \r\nGST No. : ${unitMaster[ind]['fldGSTNo']} \r\nPAN No : ${unitMaster[ind]['fldPANNo']}`;
            return str;
        } else {
            return '';
        }
    } else {
        return '';
    }
}

export function statusChecker(c) {
    if (c.fldTotalQty === 0) {
        return 'Detail Not Entered';
    } else if (c.tblProgramMappingId?.fldProgramName === 'CUTTING DC' && c.fldColors === '') {
        return 'Detail Not Entered';
    } else if (!c.fldIsPrepared) {
        return 'Not Prepared';
    } else if (c.fldIsPrepared && !c.fldIsVerified) {
        return 'Prepared';
    } else if (c.fldIsPrepared && c.fldIsVerified && !c.fldIsAuthorized) {
        return 'Verified';
    } else if (c.fldIsPrepared && c.fldIsVerified && c.fldIsAuthorized) {
        return 'Authorized';
    }
}

export const propertyModal = (status, componentId, setSelectedList, dispatch, setApiCallIds) => {
    dispatch({ type: PROPERTY_MODAL_OPEN, id: componentId });
    switch (status) {
        case 'source':
            setSelectedList('source');
            setApiCallIds(46);
            // apiCallId = 46;
            break;
        case 'department':
            setSelectedList('department');
            setApiCallIds(28);
            break;
        case 'typeOfPo':
            setSelectedList('typeOfPo');
            setApiCallIds(52);
            break;
        case 'payment':
            setSelectedList('paymentTerms');
            setApiCallIds(86);
            break;
        case 'catalouge':
            setSelectedList('catalouge');
            setApiCallIds(89);
            break;
        case 'diaList':
            setSelectedList('diaList');
            setApiCallIds(18);
            break;
        case 'typeOfFit':
            setSelectedList('typeOfFit');
            setApiCallIds(20);
            break;
        case 'sleeveType':
            setSelectedList('sleeveType');
            setApiCallIds(19);
            break;
        case 'neckType':
            setSelectedList('neckType');
            setApiCallIds(11);
            break;
        default:
            break;
    }
};

export const initialLoadCommon = (dispatch) => {
    dispatch(fetchUnitMaster());
    dispatch(fetchSeasonMaster());
    dispatch(fetchPartyDetailsData());
    dispatch(fetchCommonPropertyById(52)); //type of po
    dispatch(fetchCommonPropertyById(46)); //source
    dispatch(fetchCommonPropertyById(28)); //department
    dispatch(fetchCommonPropertyById(86)); // paymentTerms
    dispatch(fetchCommonPropertyById(57)); //Agent Name
    dispatch(fetchCommonPropertyById(58)); //Mill Name
    dispatch(fetchCommonPropertyById(18)); //Dia
    dispatch(fetchCommonPropertyById(17)); //Fabric
    dispatch(fetchCommonPropertyById(84)); // LoopLength
    dispatch(fetchCommonPropertyById(85)); // LoopLength1
    dispatch(fetchCommonPropertyById(22)) // UOM
    dispatch(fetchCommonPropertyById(72)); //Dyeing Process
    dispatch(getIpAddress());
    dispatch(fetchUnitMaster());
    dispatch(fetchHSNMaster());
    dispatch(fetchSection());
    dispatch(fetchCompanyMaster());
    // dispatch(fetchCommonPropertyById(53)); //delivery At
}

export const downloadAsImage = (componentRef, filename) => {
    exportComponentAsJPEG(componentRef, { fileName: filename, useCORS: true, scale: 2, quality: 1.0 });
};


export const downloadAsPDF0 = async (componentRef, filename, setViewFormat, dispatch) => {
    if (!componentRef.current) return;

    const element = componentRef.current;

    const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        width: element.scrollWidth,
        height: element.scrollHeight,
    });

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF({
        orientation: "portrait",
        unit: "pt",
        format: [canvas.width, canvas.height]
    });

    pdf.addImage(imgData, "PNG", 0, 0, canvas.width, canvas.height);
    pdf.save(`${filename}.pdf`);
    setViewFormat(false); // Close the view format modal after saving
    dispatch({ type: LOADING_MODAL_CLOSE });

};


export const downloadAsPDF2 = async (
    componentRef,
    filename,
    setViewFormat,
    dispatch
) => {
    if (!componentRef.current) return;

    const element = componentRef.current;

    const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        windowWidth: element.scrollWidth,
        windowHeight: element.scrollHeight,
    });

    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "pt", "a4");

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    const imgWidth = pdfWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
    heightLeft -= pdfHeight;

    while (heightLeft > 0) {
        position -= pdfHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pdfHeight;
    }

    pdf.save(`${filename}.pdf`);

    setViewFormat(false);
    dispatch({ type: LOADING_MODAL_CLOSE });
};

// working as full data how longs
export const downloadAsPDF = async (
    componentRef,
    filename,
    setViewFormat,
    dispatch
) => {
    if (!componentRef?.current) return;

    const element = componentRef.current;

    // Save original styles
    const originalOverflow = element.style.overflow;
    const originalWidth = element.style.width;

    element.style.overflow = "visible";
    element.style.width = `${element.scrollWidth}px`;

    try {
        const canvas = await html2canvas(element, {
            scale: 2,
            useCORS: true,
            width: element.scrollWidth,
            height: element.scrollHeight,
            windowWidth: element.scrollWidth,
        });

        const imgData = canvas.toDataURL("image/png");

        const pdf = new jsPDF({
            orientation: "landscape",
            unit: "pt",
            format: "a4",
        });

        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        // Scale image to fit page width
        const imgWidth = pageWidth;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        let heightLeft = imgHeight;
        let position = 0;

        // First page
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        // Remaining pages
        while (heightLeft > 0) {
            position -= pageHeight;
            pdf.addPage();
            pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
        }

        pdf.save(`${filename}.pdf`);
    } catch (err) {
        console.error("PDF error:", err);
    } finally {
        element.style.overflow = originalOverflow;
        element.style.width = originalWidth;

        // setViewFormat(false);
        dispatch({ type: LOADING_MODAL_CLOSE });
    }
};

// export const exportAsWord1 = async (componentRef) => {


//     try {
//         if (!componentRef.current) throw new Error("Component reference is null");

//         console.log('componentRef', componentRef)
//         // const component = componentRef.current;

//         // Reference to the text element
//         // const draftText = component.querySelector('.draft-text');

//         // Adjust the position of the text element
//         // draftText.style.position = 'absolute'; // or 'relative' depending on your layout
//         // draftText.style.bottom = '50px'; // Adjust as needed
//         // draftText.style.left = '50px'; // Adjust as needed


//         // draftText.style.transform = 'translate(-50%, -50%)'; // Adjust as needed
//         // draftText.style.rotate = '320deg'; // Adjust as needed
//         // draftText.style.zIndex = '99'; // Adjust as needed





//         // Capture the component as a canvas
//         const canvas = await html2canvas(componentRef.current, {
//             scale: 2, // Increase scale for better quality
//             width: componentRef.current.offsetWidth, // Set the canvas width to match the component's width
//             // backgroundColor: null, // Ensure background is captured correctly

//         });
//         const imageDataUrl = canvas.toDataURL('image/jpeg');

//         // Set the width of the image to match the Word document's full width (8.5 inches minus margins)
//         const imageWidth = 600; // Adjust based on Word's typical DPI (96 DPI is common, 600px is about 6.25 inches)

//         // Create a new Word document
//         const doc = new Document({
//             sections: [
//                 {
//                     children: [
//                         new Paragraph({
//                             children: [
//                                 new ImageRun({
//                                     data: imageDataUrl,
//                                     transformation: {
//                                         width: imageWidth,
//                                         height: (canvas.height * imageWidth) / canvas.width, // Maintain aspect ratio
//                                     },
//                                 }),
//                             ],
//                         }),
//                     ],
//                 },
//             ],
//         });

//         // Generate the Word document
//         const blob = await Packer.toBlob(doc);
//         saveAs(blob, 'exported-component.docx');
//     } catch (error) {
//         console.error('Error during export:', error.message);
//     }
// };


// export const exportAsWord = async (componentRef) => {
//     try {
//         if (!componentRef.current) throw new Error("Component reference is null");

//         // Example: Extract and convert component's content into editable Word content
//         const paragraphs = [];

//         // Assume componentRef contains paragraphs or other text elements
//         const textElements = componentRef.current.querySelectorAll('p, h1, h2, h3, span');

//         textElements.forEach(element => {
//             // Create a new Paragraph for each text element
//             const paragraph = new Paragraph({
//                 children: [
//                     new TextRun({
//                         text: element.innerText,
//                         bold: element.tagName.startsWith('H'), // Bold if it's a heading (H1, H2, H3)
//                         size: element.tagName.startsWith('H') ? 32 : 24, // Larger size for headings
//                     }),
//                 ],
//             });

//             paragraphs.push(paragraph);
//         });

//         // Create a new Word document
//         const doc = new Document({
//             sections: [
//                 {
//                     children: paragraphs,
//                 },
//             ],
//         });

//         // Generate the Word document
//         const blob = await Packer.toBlob(doc);
//         saveAs(blob, 'exported-content.docx');
//     } catch (error) {
//         console.error('Error during export:', error.message);
//     }
// };



export const downloadAsImageScrollable = (componentRef, filename) => {
    const el = componentRef.current;

    // save original styles
    const originalOverflowX = el.style.overflowX;
    const originalWidth = el.style.width;

    // force full width
    el.style.overflowX = 'visible';
    el.style.width = 'max-content';

    exportComponentAsPNG(componentRef, {
        fileName: filename,
        useCORS: true,
        scale: 4,
    }).then(() => {
        // restore styles
        el.style.overflowX = originalOverflowX;
        el.style.width = originalWidth;
    });
};


export const setGridPageIndex = (val) => {
    localStorage.setItem(`_pageIndex`, val);
};

export const getSavedPageIndex = () => {
    const pageIndex = parseInt(localStorage.getItem(`_pageIndex`), 10);
    return isNaN(pageIndex) ? 0 : pageIndex;
};
export const resetPagingIndex = () => {
    localStorage.removeItem(`_pageIndex`);

}

export const fileUploadAll = (files, inwardId, dispatch) => {
    if (inwardId?.length > 0 && files !== undefined) {
        let formData = new FormData();
        let formData2 = new FormData();
        formData.append('filename', files);
        formData2.append('filename', files);
        formData.append('FldFKCompany', inwardId[0]?.fldFKCompany);
        formData.append('FldFKUser', inwardId[0].fldFKUser);
        formData.append('FldFKImageCategory', inwardId[0].fldFKImageCategory);
        formData.append('FldDescription', 'Yarn Inward Upload');
        formData.append('FldSetAsDefault', inwardId[0].fldSetAsDefault);
        formData.append('FldFKUnit', inwardId[0]?.fldFKUnit);
        formData.append('FldImageCategory', inwardId[0].fldImageCategory);
        formData.append('FldImageCode', inwardId[0].fldImageCode);
        formData.append('FldTableName', inwardId[0].fldTableName);
        formData.append('FldControllerName', inwardId[0].fldControllerName);
        formData.append('FldReferenceId', inwardId[0].fldReferenceId);
        dispatch(uploadCompanyMasterLogo(formData, formData2));
    }

}

export const openPdf = (file) => {
    if (file.fldExtension === "pdf" && file.imageID) {
        const pdfWindow = window.open("");
        pdfWindow.document.write(
            `<iframe width='100%' height='100%' src='data:application/pdf;base64,${file.imageID}'></iframe>`
        );
    }
};
export const resetDataGrid = (setIsForceRender) => {
    setIsForceRender(false)
    setTimeout(() => {
        setIsForceRender(true)
    }, 50)
}

export const onExporting = (e, name) => {
    if (e.format === 'xlsx') {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet(name);
        exportDataGrid({
            component: e.component,
            worksheet,
            autoFilterEnabled: true
        }).then(() => {
            workbook.xlsx.writeBuffer().then((buffer) => {
                saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${name}.xlsx`);
            });
        });
        e.cancel = true;
    } else if (e.format === 'pdf') {
        const doc = new jsPDF();
        exportDataGridToPdf({
            jsPDFDocument: doc,
            component: e.component
        }).then(() => {
            doc.save(`${name}.pdf`);
        });
    }
}